/**
 * @generated SignedSource<<4e5e80158ec56859638dcae0bd5f40db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineComment_todoComment$data = {
  readonly comment: string;
  readonly createdAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly createdByActor: {
    readonly " $fragmentSpreads": FragmentRefs<"SignedActor_actor">;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "TodoTimelineComment_todoComment";
};
export type TodoTimelineComment_todoComment$key = {
  readonly " $data"?: TodoTimelineComment_todoComment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineComment_todoComment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineComment_todoComment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "createdByActor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignedActor_actor"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "createdAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoComment",
  "abstractKey": null
};

(node as any).hash = "b2640ca5b35fc7112c36e46fee10477c";

export default node;
